/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalDependencies } from './dependenciesEqual.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createDeepEqual } from '../../factoriesAny.js';
export var deepEqualDependencies = {
  equalDependencies,
  typedDependencies,
  createDeepEqual
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesDeepEqual.generated.js
// module id = OFxh
// module chunks = 3